import React from 'react';

const AW = ({ className }: { className?: string }) => (
  <svg
    className={className}
    width="21"
    height="15"
    viewBox="0 0 21 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_3_203"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="21"
      height="15"
    >
      <path
        d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_3_203)">
      <path
        d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
        fill="#3D87E0"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.485 4.485C5.355 4.43 6 4.235 6 4C6 3.766 5.355 3.57 4.485 3.515C4.43 2.645 4.235 2 4 2C3.766 2 3.57 2.645 3.515 3.515C2.645 3.57 2 3.765 2 4C2 4.234 2.645 4.43 3.515 4.485C3.57 5.355 3.765 6 4 6C4.234 6 4.43 5.355 4.485 4.485Z"
        fill="#D4062F"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.485 4.485C5.355 4.43 6 4.235 6 4C6 3.766 5.355 3.57 4.485 3.515C4.43 2.645 4.235 2 4 2C3.766 2 3.57 2.645 3.515 3.515C2.645 3.57 2 3.765 2 4C2 4.234 2.645 4.43 3.515 4.485C3.57 5.355 3.765 6 4 6C4.234 6 4.43 5.355 4.485 4.485ZM4.515 4.985L4.985 4.515C4.91 5.713 4.66 6.5 4 6.5C3.34 6.5 3.09 5.712 3.016 4.516L3.484 4.984C2.288 4.91 1.5 4.66 1.5 4C1.5 3.34 2.288 3.09 3.484 3.016L3.016 3.484C3.09 2.288 3.34 1.5 4 1.5C4.66 1.5 4.91 2.288 4.984 3.484L4.516 3.016C5.712 3.09 6.5 3.34 6.5 4C6.5 4.66 5.712 4.91 4.516 4.984L4.515 4.985Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 9H21V10H0V9ZM0 11H21V12H0V11Z"
        fill="#FAD800"
      />
      <path
        d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
        stroke="black"
        strokeOpacity="0.1"
      />
    </g>
  </svg>
);

export default AW;
